module.exports = __webpack_public_path__ + "media/images/front/icon_earth_01-abec597b4cd14e7c02303f148faa78d4.svg";